module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "g-bg-main g-pt-100 g-pb-50"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row g-mb-40"
  }, [(_vm.CheckLogin()) ? _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }, [_c('b', {
    staticClass: "g-font-size-18 g-color-footer-links"
  }, [_vm._v("Pages")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled g-mt-20"
  }, [_c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Home')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_vm._v("Order Now")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_vm._v("Track Orders")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Frames')
      }
    }
  }, [_vm._v("Frames")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resources')
      }
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('UserAccount')
      }
    }
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help")])])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.CheckLogin()) ? _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 col-lg-3 order-md-2 g-mb-30"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3 order-md-1 g-mb-30"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }, [_c('b', {
    staticClass: "g-font-size-18 g-color-footer-links"
  }, [_vm._v("Links and More")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled g-mt-20"
  }, [_c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.onesight.essilorluxottica.com"
    }
  }, [_vm._v("OneSight EssilorLuxottica Foundation")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "https://www.evfusa.org/terms-and-conditions"
    }
  }, [_vm._v("Terms of Use")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.evfusa.org/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.evfusa.org/disclosures"
    }
  }, [_vm._v("Disclosures")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "https://www.essilorusa.com/about/ethics-compliance"
    }
  }, [_vm._v("Ethics & Compliance")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-6 g-mb-20"
  }, [_c('img', {
    staticClass: "evf-watermark-2",
    attrs: {
      "src": "/static/assets/img/logo/Powered_by_OSELF-white.png"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-inline mb-0 evf-social-2 g-my-10"
  }, [_c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--xs u-shadow-v32",
    attrs: {
      "href": "https://www.facebook.com/onesight/"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-facebook.png",
      "alt": "facebook"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32",
    attrs: {
      "href": "https://www.linkedin.com/company/onesightessilorluxotticafoundation"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-linkedin.png",
      "alt": "linkedin"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--xs u-shadow-v32",
    attrs: {
      "href": "https://twitter.com/onesightorg"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-twitter.png",
      "alt": "twitter"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-4"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32",
    attrs: {
      "href": "https://www.instagram.com/onesight/"
    }
  }, [_c('img', {
    staticClass: "social-media__icon",
    attrs: {
      "src": "/static/onesight/white-instagram.png",
      "alt": "instagram"
    }
  })])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ec4fedc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ec4fedc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FooterComponent.vue
// module id = 496
// module chunks = 4